<template>
  <div>
    <div class="page-header"><h2><span class="breadcrumb-level">系统管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">系统配置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">首页宠物选择器</span></h2></div>
    <el-form label-width="120px">
      <div v-for="item in list" :key="item.id" class="pet-item">
        <div class="pet-label">{{ item.name }}</div>
        <div class="pet-icons">
          <div class="icon-group">
            <div class="icon-label-text">图标</div>
            <Upload v-model="item.icon_url" :max-count="1" tip="推荐尺寸 宽 88 × 高 88 px" />
          </div>
          <div class="icon-group">
            <div class="icon-label-text" style="font-size:12px;color:#999;">跳转路径已前端固定</div>
          </div>
        </div>
      </div>
    </el-form>
    <div style="margin-top:20px">
      <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';

const list = ref([]);
const saving = ref(false);

const fetchData = async () => {
  try {
    const res = await contentApi.getPetSelectors();
    list.value = (res.data || []).map(i => ({ ...i }));
  } catch { ElMessage.error('获取失败'); }
};

const handleSave = async () => {
  saving.value = true;
  try {
    for (const item of list.value) {
      await contentApi.updatePetSelector(item.id, {
        icon_url: item.icon_url,
        page_path: item.page_path,
      });
    }
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); }
  finally { saving.value = false; }
};

onMounted(fetchData);
</script>

<style scoped>
.pet-item { border: 1px solid #e0e0e0; border-radius: 12px; padding: 20px; margin-bottom: 16px; background: #fff; max-width: 600px; }
.pet-label { font-size: 15px; font-weight: 600; margin-bottom: 12px; color: #333; }
.pet-icons { display: flex; gap: 20px; align-items: center; }
.icon-group { display: flex; flex-direction: column; align-items: center; gap: 6px; }
.icon-label-text { font-size: 12px; color: #999; }
</style>
